<div [ngClass]="customOverlayClass || 'popup-overlay'" *ngIf="isPopupVisible | async"  (click)="closePopup()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div *ngIf="loading" class="loading-indicator">Loading...</div>
    <div *ngIf="!loading">
      <div class="row">
        <div class="col-12 notifyTitle" [i18n]="'df-management.df-logs.notifications.title'"></div>
      </div>
      <ng-container *ngIf="notifications && notifications.length > 0; else noNotifications">
        <div *ngFor="let notification of notifications" class="card notifyCard">
          <div class="notifyMessage">{{ notification.message }}</div>
          <div class="notifySubMessage" *ngIf="notification.subMessage">{{ notification.subMessage }}</div>
          <div class="row">
            <div class="col-sm-4 technicalErrors" *ngIf="!notification.subMessage">
              <span [i18n]="'df-management.df-logs.notifications.technical'"></span> {{ notification.technicalErrors }}
            </div>
            <div class="col-sm-4 businessErrors" *ngIf="!notification.subMessage">
              <span [i18n]="'df-management.df-logs.notifications.bussiness'"></span> {{ notification.businessErrors }}
            </div>
            <div class="col-sm-4 notifyDate" [ngClass]="{'marginLeft': notification.subMessage}">
              {{ notification.createdDate | dfFullDate }}
            </div>
          </div>
        </div>
        </ng-container>
        <div class="noAlerts">
          <ng-template #noNotifications>
            <div class="no-alerts-message" [i18n]="'df-management.df-logs.notifications.notAlerts'"></div>
          </ng-template>
        </div>
    </div>
    <span class="close-icon" (click)="closePopup()">&#xf00d;</span>
  </div>
</div>
